{
  "es": {
    "locale_field": {
      "fallback_tooltip": "Cuando no se introduce texto para este idioma, se usará este texto predeterminado como alternativa."
    }
  }
}
